"use strict";
/**
 * AngularJS toast module.
 *
 * @packageDocumentation
 * @module Toast
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Angular Imports
var angular_1 = tslib_1.__importDefault(require("angular"));
//#endregion
//#region Toastr Imports
require("angular-toastr");
require("angular-toastr/dist/angular-toastr.css");
//#endregion
//#region Assets Imports
require("./toast.styles.scss");
//#endregion
//#region Module Setup
var toast_service_1 = require("./toast.service");
exports.TOAST_MODULE_NAME = 'imr.controls.services.toast';
var toastModule = angular_1.default.module(exports.TOAST_MODULE_NAME, [
    'toastr',
]);
toastModule.provider(toast_service_1.SERVICE_NAME, toast_service_1.IMRToastServiceProvider);
//#endregion
//#region Toastr Setup
toastModule.config([
    'toastrConfig',
    function (toastrConfig) {
        angular_1.default.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 0,
            positionClass: 'toast-bottom-center',
            target: 'body',
        });
    },
]);
//#endregion
//# sourceMappingURL=toast.module.js.map